import { render, staticRenderFns } from "./UserGroupNode.vue?vue&type=template&id=28291b7a"
import script from "./UserGroupNode.vue?vue&type=script&lang=js"
export * from "./UserGroupNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports